// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__LDZIv","label":"Category_label__o5ONg","content":"Category_content__tfn-v","header":"Category_header__3VHm0","location":"Category_location__Nggod"};